import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "deletion-business-table-page" }
const _hoisted_2 = { class: "deletion-business-table-page__title page-title" }
const _hoisted_3 = { class: "page-title__label" }
const _hoisted_4 = { class: "deletion-business-table-page__deletion-business-table deletion-business-table" }
const _hoisted_5 = { class: "deletion-business-table__header-area" }
const _hoisted_6 = { class: "deletion-business-table__header-area--control-items" }
const _hoisted_7 = { class: "deletion-business-table__header-area--pagination-items" }
const _hoisted_8 = { class: "deletion-business-table-page__table-area" }

import { onMounted } from 'vue';
import { useDeletionBusinessStore } from './deletionBusinessStore';
import { storeToRefs } from 'pinia';
import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';
import { GetDeletionBusinessAdapter } from '../adapters/getDeletionBusinessAdapter';
import { i18n } from '@/i18n';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { GetDeletionBusinessUseCase } from '../useCases/getDeletionBusinessUseCase';
import { InventoryRepository } from '@/coreInfrastructureModule/Repositories/InventoryRepository';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import DeleteBusinessModal from './components/modal/DeleteBusinessModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const inventoryRepository = new InventoryRepository();
const getDeletionBusinessUseCase = new GetDeletionBusinessUseCase();
const getDeletionBusinessAdapter = new GetDeletionBusinessAdapter();

const store = useDeletionBusinessStore(inventoryRepository, getDeletionBusinessUseCase, getDeletionBusinessAdapter)();
const { state } = storeToRefs(store);

const t = i18n.t;

onMounted(async () => {
  await store.init();
});

/**
 * 取引削除確認モーダルを開く
 */
const openDeleteBusinessModal = () => {
  state.value.deleteBusinessModalState = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('取引削除')), 1)
      ]),
      _createVNode(RegisterBusinessPageTab, { class: "deletion-business-table-page__page-tab" }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(FilterModalButton, {
              "filter-modal-type": "deletion-business",
              "select-input-index": 0,
              "filter-items": _unref(store).getFilterItemsValue().value,
              onApply: _cache[0] || (_cache[0] = (filteredContents) => _unref(store).onAppliedFilterModal(filteredContents))
            }, null, 8, ["filter-items"]),
            _createVNode(TextButton, {
              "button-style": 'btn-secondary',
              size: 'btn-md',
              "on-click": openDeleteBusinessModal,
              disabled: !_unref(state).checkedIds.length,
              class: "bulk-action-button-container__export-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('削除する')), 1)
              ], undefined, true),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_unref(state).pagingOptions)
              ? (_openBlock(), _createBlock(Pagination, {
                  key: 0,
                  "paging-options": _unref(state).pagingOptions,
                  "is-loading": _unref(state).loadingState.status.type === 'loading',
                  class: "pagination",
                  onOnChangePage: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).onChangePaging($event)))
                }, null, 8, ["paging-options", "is-loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createBlock(NewBaseTableContent, {
            key: _unref(state).renderingKey,
            "prop-table-content-properties": _unref(state).tableContentProperties,
            "prop-display-objects": _unref(state).tableContentItems,
            "prop-loading-status": _unref(state).loadingState,
            "prop-table-type": 'deletionBusinessTable',
            "prop-is-reset": _unref(state).isRefreshTable,
            class: "unordered-items-table__contains unordered-items-table__contains--table",
            onChecked: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).checkedIds = $event)),
            onOnClickSort: _cache[3] || (_cache[3] = (sortKey, isAsc) => _unref(store).sortTableContentItems(sortKey, isAsc)),
            onReload: _unref(store).reloadTable
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "prop-is-reset", "onReload"]))
        ])
      ])
    ]),
    _createVNode(DeleteBusinessModal, {
      "modal-state": _unref(state).deleteBusinessModalState,
      "select-input-index": 1,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).deleteBusinessModalState = false)),
      onRemove: _unref(store).deleteBusiness
    }, null, 8, ["modal-state", "onRemove"])
  ], 64))
}
}

})